import { watch } from 'vue'
import { LANDING_HANDOFF_COOKIE } from '~/utils/canonicalUrl'
import { getBrowserSessionStorage, recordVisitorJourneyPage } from '~/utils/visitorJourney'

// Reads (and clears) the tracking params the canonical redirect stripped from the landing URL.
const consumeLandingHandoff = () => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${LANDING_HANDOFF_COOKIE}=([^;]*)`))
  if (!match) return ''
  document.cookie = `${LANDING_HANDOFF_COOKIE}=; Max-Age=0; Path=/; SameSite=Lax`
  try {
    return decodeURIComponent(match[1] || '')
  } catch {
    return ''
  }
}

/**
 * Keeps a session-scoped journey (referrer, UTM, pages seen) so lead forms
 * can send provenance with the request. Nothing leaves the browser until a
 * form is submitted; backoffice routes are ignored.
 */
export default defineNuxtPlugin(() => {
  const route = useRoute()
  const storage = getBrowserSessionStorage()
  if (!storage) return

  watch(
    () => route.path,
    (path) => {
      if (path === '/app' || path.startsWith('/app/')) return
      const handoff = consumeLandingHandoff()
      const target = new URL(`${window.location.origin}${route.fullPath}`)
      new URLSearchParams(handoff).forEach((value, key) => target.searchParams.set(key, value))
      recordVisitorJourneyPage(storage, target.toString(), document.referrer)
    },
    { immediate: true }
  )
})
